const globalStyleId = 'gs-text-main';
const defaultSelector = {
  selector: '#{mID} .gf_badge-text-wrap',
};
export default {
  defaultClass: 'gf_gs-text-paragraph-2',
  settingGroups: {
    [globalStyleId]: {
      // "badgeColor": {
      //   ...defaultSelector,
      //   inherit: "text.fontColor",
      //   cssAttr: "color"
      // },
      badgeFontSize: {
        ...defaultSelector,
        inherit: 'text.fontSize',
        cssAttr: 'font-size',
        listUnit: 'px',
      },
      badgeTextLineHeight: {
        ...defaultSelector,
        inherit: 'text.lineHeight',
        cssAttr: 'line-height',
        listUnit: 'em',
      },
      badgeFont: {
        ...defaultSelector,
        inherit: 'text.fontFamily',
        cssAttr: 'font-family',
      },
    },
  },
};

export const P_IMAGE_SETTING = [
  {
    gsId: globalStyleId,
    gsSettingGroup: 'Badge',
    isRenderColumn: false,
    prefix: 'gf_gs-text-',
    typeSetting: 'heading-paragraph',
    isSettingAdvand: true,
  },
];
